import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { OuterContainer, CheckBoxLabel } from "../../EventCreation/styles";
import { Formik } from "formik";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  CustomInputField,
  CheckboxContainer,
  CustomCheckBox,
} from "../../common/FormInputs";
import { PrimaryCTAButton, SecondaryCTAButton } from "../../common/Buttons";
import { AddCircleOutline } from "@material-ui/icons";
import { CustomRadioGroup } from "../../common/FormInputs";
import COLORS from "../../../assets/Colors";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import {
  getErrorMessage,
  revertPayload,
  transformPayload,
} from "../../../helpers/functions";
import EventService from "../../../services/EventService";
import { navigate } from "@reach/router";
import { formsValidationSchema } from "../../../helpers/validationSchema";
import { ButtonContainer, FormControl } from "../FormInputs";
import _ from "lodash";
import FormField from "../FormInputs";
// import { HelperText } from "../FormInputs";

const CustomFiledManagement = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const [items, setItems] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const initialState = {
    noOfInput: "",
    type: "text",
    formField: "",
  };
  const [clickedButton, setClickedButton] = useState("");

  const buttons = [
    {
      label: "Text Input",
      type: "button",
      name: "text",
    },
    {
      label: "Drop Down",
      type: "button",
      name: "select",
    },
    {
      label: "Check Box",
      type: "button",
      name: "checkbox",
    },
    {
      label: "Email Id",
      type: "button",
      name: "emailId",
    },
    {
      label: "Radio Button",
      type: "button",
      name: "radio",
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  const switchItems = [
    { name: "firstName", label: "First Name", type: "switch" },
    { name: "lastName", label: "Last Name", type: "switch" },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "switch",
    },
    {
      name: "emailId",
      label: "Email Address",
      type: "switch",
    },
    { name: "portfolioNumber", label: "Portfolio Number", type: "switch" },
    { name: "company", label: "Company", type: "switch" },
    {
      name: "enableOnlineOffline",
      label: "Enable online / offline",
      type: "switch",
    },
  ];

  const input_one = [{ name: "label", label: "Label", type: "text" }];
  const input_two = [
    {
      name: "noOfInput",
      label: "No of Input",
      type: "text",
      inputType: "text",
    },
  ];

  const registration_from_position = [
    {
      label: "Registration Form Position",
      name: "registrationformPosition",
      type: "radio",
      menuItems: [
        { label: "Left of the page", value: "left" },
        { label: "Right of the page", value: "right" },
        { label: "Center of the page", value: "center" },
      ],
    },
  ];

  const addItems = (values, setFieldValue) => {
    const new_items = [
      ...values?.items,
      {
        noOfInput: "",
        type: "text",
        formField: "",
      },
    ];
    setFieldValue("items", new_items);
  };

  const deleteItems = (index, values, setFieldValue) => {
    const new_items = [...values?.items].filter((ci, idx) => idx !== index);
    setFieldValue("items", new_items);
  };

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "forms");
        setItems({
          ...response,
          customFields:
            response?.customFields !== null &&
            revertPayload(response?.customFields),
        });
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } else {
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "forms");
      setItems({
        ...response,
        customFields: revertPayload(response?.customFields),
      });
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description submit Custom filed addition
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        ...values,
        customFields: transformPayload(
          values?.items.filter(
            (obj) => obj.hasOwnProperty("label") && obj.label.length > 0,
          ),
        ),
      };
      delete payload.items;
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        navigate(`/dashboard/eventmanager/event-settings/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const handleChangeField = (event, name, item, values, setFieldValue) => {
    if (
      values?.standardField["firstName"] &&
      values?.standardField["lastName"]
    ) {
      setFieldValue(`standardField.fullName`, false);
    }
    if (item.name === "firstName") {
      setFieldValue(`standardField.fullName`, false);
      setFieldValue(name, event.target.checked);
    }
    if (item.name === "lastName") {
      setFieldValue(`standardField.fullName`, false);
      setFieldValue(name, event.target.checked);
    }
    setFieldValue(name, event.target.checked);
  };

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "user_access_and_registration":
        id?.id
          ? navigate(
              `/dashboard/eventmanager/form-settings/user-access-registration/${id?.id}`,
            )
          : navigate(
              `/dashboard/eventmanager/form-settings/user-access-registration`,
            );
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "User access and registration",
                "Custom Field Addition",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : [
                "Event Manager",
                "User access and registration",
                "Custom Field Addition",
              ]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            standardField: {
              preValidateLabel: items?.preValidateUsers?.preValidateLabel || "",
              preValidateRegistration:
                items?.preValidateUsers?.preValidateRegistration || "",
              fullName: items?.standardField?.fullName || false,
              firstName: items?.standardField?.firstName || false,
              lastName: items?.standardField?.lastName || false,
              phoneNumber: items?.standardField?.phoneNumber || false,
              portfolioNumber: items?.standardField?.portfolioNumber || false,
              emailId: items?.standardField?.emailId || false,
              company: items?.standardField?.company || false,
              enableOnlineOffline:
                items?.standardField?.enableOnlineOffline || false,
              registrationformPosition:
                items?.standardField?.registrationformPosition || "center",
            },
            items: items?.customFields?.length
              ? items?.customFields?.map((item) => ({
                  ...item,
                  label: item?.label,
                  noOfInput: item?.noOfInput || "",
                  type: item?.type || "",
                  inputBox: item.inputBox || "",
                  formField: item?.formField || "",
                }))
              : [initialState] || [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={formsValidationSchema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            handleChange,
            setFieldValue,
            resetForm,
          }) => (
            <FormContainer>
              <Container style={{ justifyContent: "flex-end" }}>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Standard Fields</Heading>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "5px",
                    }}
                  >
                    <Grid container spacing={2} style={{ marginTop: "16px" }}>
                      <Grid
                        item
                        xs={12}
                        key={"fullName"}
                        style={styles.gridItem}
                      >
                        {[
                          {
                            name: "fullName",
                            label: "Full Name",
                            type: "switch",
                          },
                        ].map((item) => (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={4}
                            xl={2}
                            key={item.name}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{
                                item,
                                values,
                                errors,
                                touched,
                              }}
                              name={`standardField.fullName`}
                              value={values.standardField["fullName"]}
                              handleChange={(event) => {
                                if (`standardField.fullName`) {
                                  setFieldValue(
                                    `standardField.firstName`,
                                    false,
                                  );
                                  setFieldValue(
                                    `standardField.lastName`,
                                    false,
                                  );
                                  setFieldValue(`standardField.fullName`, true);
                                }
                                if (values.standardField["fullName"]) {
                                  setFieldValue(
                                    `standardField.fullName`,
                                    false,
                                  );
                                }
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ marginTop: "16px" }}>
                      <OrLabel
                        style={{ marginLeft: isBigScreen ? "215px" : "155px" }}
                      >
                        {"--Or--"}
                      </OrLabel>
                    </Grid>{" "}
                    <div style={{ display: isBigScreen && "flex" }}>
                      <Grid
                        container
                        spacing={2}
                        style={{
                          marginTop: "16px",
                        }}
                      >
                        {switchItems.map((item) => (
                          <Grid
                            item
                            sm={6}
                            md={4}
                            key={item.name}
                            style={styles.gridItem}
                          >
                            <FormField
                              {...{
                                item,
                                handleChange,
                                values,
                                errors,
                                touched,
                              }}
                              handleChange={(event) =>
                                handleChangeField(
                                  event,
                                  `standardField.${item.name}`,
                                  item,
                                  values,
                                  setFieldValue,
                                )
                              }
                              error={errors[item.name]}
                              value={values.standardField[item.name]}
                              name={`standardField.${item.name}`}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        marginTop: "16px",
                      }}
                    >
                      {registration_from_position.map((item, idx) => (
                        <Grid
                          item
                          xs={12}
                          key={item.name}
                          style={styles.gridItem}
                        >
                          <FormField
                            {...{
                              item,
                              handleChange,
                              values,
                              errors,
                              touched,
                            }}
                            direction={"row"}
                            error={errors[item.name]}
                            value={values.standardField[item.name]}
                            name={`standardField.${item.name}`}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    <div style={{ marginBottom: "20px" }}>
                      {errors?.standardField?.length && (
                        <HelperText>{errors?.standardField}</HelperText>
                      )}
                    </div>
                  </Paper>
                  {values?.items.map((arr, index) => (
                    <Paper
                      elevation={3}
                      style={{
                        padding: 16,
                        border: "1px solid #e1e3ee",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <GridLabel>Custom Fields</GridLabel>
                      <PollContainer>
                        <>
                          <GridButtons>
                            {buttons.map((button) => (
                              <PrimaryCTAButton
                                style={{
                                  marginTop: "10px",
                                  backgroundColor:
                                    arr["type"] === button.name
                                      ? "#C0DEFF"
                                      : "#e1e3ee",
                                  border: "1px solid #e1e3ee",
                                  color: "#293461",
                                }}
                                onClick={() =>
                                  setFieldValue(
                                    `items[${index}].type`,
                                    button.name,
                                  )
                                }
                              >
                                {button.label}
                              </PrimaryCTAButton>
                            ))}
                          </GridButtons>
                          <MainContainer>
                            <div>
                              {input_one.map((item, idx) => (
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  spacing={3}
                                  style={{ padding: 16 }}
                                >
                                  <FormControlLabel
                                    labelPlacement="top"
                                    label={
                                      <SwitchLabel {...{ isBigScreen }}>
                                        {item.label}
                                      </SwitchLabel>
                                    }
                                    control={
                                      <CustomInputField
                                        style={{
                                          width: isBigScreen ? "250px" : "auto",
                                        }}
                                        variant="outlined"
                                        value={arr[item.name]}
                                        name={`items[${index}].${item.name}`}
                                        placeholder="Enter label"
                                        onChange={(e) =>
                                          setFieldValue(
                                            `items[${index}].${item.name}`,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    }
                                  />
                                </Grid>
                              ))}
                              {["text", "emailId"].includes(arr["type"])
                                ? null
                                : input_two.map((item, idx) => (
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      spacing={3}
                                      style={{ padding: 16 }}
                                    >
                                      <FormControlLabel
                                        labelPlacement="top"
                                        label={
                                          <SwitchLabel {...{ isBigScreen }}>
                                            {item.label}
                                          </SwitchLabel>
                                        }
                                        control={
                                          <CustomInputField
                                            style={{
                                              width: isBigScreen
                                                ? "250px"
                                                : "auto",
                                            }}
                                            variant="outlined"
                                            value={arr[item.name]}
                                            name={`items[${index}].${item.name}`}
                                            placeholder="Enter no of input"
                                            onChange={(e) =>
                                              setFieldValue(
                                                `items[${index}].${item.name}`,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        }
                                      />
                                    </Grid>
                                  ))}
                            </div>
                            {["text", "emailId"].includes(
                              arr["type"],
                            ) ? null : (
                              <>
                                <InnerContainer>
                                  {arr["type"] === "radio" ? (
                                    <div style={{ marginTop: "15px" }}>
                                      <CustomRadioGroup
                                        radioInputs={Array.from(
                                          { length: arr["noOfInput"] },
                                          (_, index) => {
                                            const optionName = `option${
                                              index + 1
                                            }`;
                                            return {
                                              name: optionName,
                                              value: optionName,
                                              label: `Option ${index + 1}`,
                                            };
                                          },
                                        )}
                                        direction="column"
                                        value={arr["formField"]}
                                        name={`items[${index}].formField`}
                                        handleChange={handleChange}
                                        {...{ values }}
                                      />
                                    </div>
                                  ) : arr["type"] === "checkbox" ? (
                                    Array.from(
                                      { length: arr["noOfInput"] },
                                      (_, index) => {
                                        const optionName = `optionCheckbox${
                                          index + 1
                                        }`;
                                        return {
                                          name: optionName,
                                          value: optionName,
                                          label: `Option ${index + 1}`,
                                        };
                                      },
                                    ).map((item) => (
                                      <CheckboxContainer
                                        style={{ marginTop: "5px" }}
                                      >
                                        <CustomCheckBox
                                          checked={arr[item.name]}
                                          value={arr[item.name]}
                                          name={`items[${index}].${item.name}`}
                                          onChange={handleChange}
                                        />
                                        <CheckBoxLabel
                                          style={{
                                            fontFamily:
                                              theme.fonts.primaryFontSemiBold,
                                            marginRight: "5px",
                                          }}
                                        >
                                          {item.label}
                                        </CheckBoxLabel>
                                      </CheckboxContainer>
                                    ))
                                  ) : null}
                                </InnerContainer>
                                <InnerContainer
                                  style={{
                                    margin: "5px",
                                    width: isBigScreen && "35%",
                                  }}
                                >
                                  {Array.from(
                                    { length: arr["noOfInput"] },
                                    (_, index) => {
                                      const optionName = `value${index + 1}`;
                                      return {
                                        name: optionName,
                                        value: "label",
                                      };
                                    },
                                  ).map((input) => (
                                    <CustomInputField
                                      variant="outlined"
                                      type="text"
                                      style={{ marginTop: "5px" }}
                                      placeholder="Enter options"
                                      value={arr[input.name]}
                                      name={`items[${index}].${input.name}`}
                                      onChange={handleChange}
                                    />
                                  ))}
                                </InnerContainer>
                              </>
                            )}
                          </MainContainer>
                        </>
                      </PollContainer>
                      {values.items.length > 1 && (
                        <Grid
                          item
                          xs={12}
                          style={{
                            textAlign: "left",
                            marginTop: "20px",
                          }}
                        >
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            onClick={() =>
                              deleteItems(index, values, setFieldValue)
                            }
                          >
                            Delete
                          </PrimaryCTAButton>
                        </Grid>
                      )}
                    </Paper>
                  ))}
                  <ButtonWrapper>
                    <SecondaryCTAButton
                      onClick={() => addItems(values, setFieldValue)}
                      style={{ paddingLeft: 0 }}
                    >
                      <AddCircleOutline
                        style={{ marginRight: "10px", marginLeft: "5px" }}
                      />{" "}
                      Add More Fields
                    </SecondaryCTAButton>
                  </ButtonWrapper>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default CustomFiledManagement;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const SwitchLabel = styled(Typography)(({ isBigScreen, width }) => ({
  width: isBigScreen ? (width ? width : "250px") : "120px",
  color: " #949ab0",
  fontSize: "14px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 95%;
  }
`;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const GridButtons = styled.div`
  width: auto;
  @media ${theme.breakpoints.md_up} {
    width: 20%;
  }
`;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
`;

const PollContainer = styled.div`
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    display: flex;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  border: 1px solid #e1e3ee;
  margin-right: 90px;
  border-radius: 10px;
  padding: 16px;
  @media ${theme?.breakpoints?.md_up} {
    display: flex;
    height: auto;
  }
`;

const InnerContainer = styled.div`
  padding-top: 18px;
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

const OrLabel = styled.div`
  color: ${COLORS.COLOR_DARK},
  fontSize: 15px,
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

const HelperText = styled.div`
  position: absolute;
  font-size: 10px;
  font-family: openSans-SemiBold, sans-serif;
  color: #f44336;
  margin-bottom: 10px;
`;
